<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtit"><a id="page_vi"></a>Acknowledgements</h2>
<p class="noindent">This book has been greatly assisted by a number of the author’s friends. Foremost among these is Lindsay Siviter, for loaning crucial texts, for commenting on this book’s chapters and for help and encouragement. John Gauss has, as always, been kind enough to correct the author’s grammar and English. John Curnow corrected parts of <span href="#/xhtml/13_Chapter8" title="Link target outside of Sample">Chapter 8</span>. Lindsay Siviter, John Coulter, Gareth Long and Paul Lang helped with the supply of pictures. Ros Seton has also provided advice.</p>
<p class="indent">This book is dedicated to Nikki Norris who prefers fact to fiction.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Acknowledgements.vue?ef58c87e